<mat-vertical-stepper
  orientation="vertical"
  linear
  #stepper
  (selectionChange)="onStepChange($event)"
>
  <ng-template matStepperIcon="edit">
    <mat-icon>done</mat-icon>
  </ng-template>

  <mat-step
    *ngFor="let item of stepperData; let i = index"
    [completed]="item.completed"
  >
    <ng-template matStepLabel>
      <span
        matTooltip="{{ item.tooltip | translate }}"
        matTooltipPosition="below"
      >
        {{ item.stepper | translate }}
      </span>
    </ng-template>
  </mat-step>
</mat-vertical-stepper>
